import { jsx as _jsx } from "react/jsx-runtime";
import { toClassName } from '../../utils/ClassNameUtils.js';
export const SelectDisplay = ({ fullWidth, value, onChange, children, }) => {
    return (_jsx("div", { className: toClassName('select', fullWidth && 'is-width-100'), children: _jsx("select", { className: fullWidth ? 'is-width-100' : undefined, value: value, onChange: onChange, children: children }) }));
};
SelectDisplay.displayName = 'SelectDisplay';
SelectDisplay.Option = ({ value, disabled, children }) => {
    return (_jsx("option", { value: value, disabled: disabled, children: children }));
};
SelectDisplay.Option.displayName = 'SelectDisplay.Option';
//# sourceMappingURL=SelectDisplay.js.map